import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

export default function MessagesFAB() {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    let isMounted = true;

    const fetchUnread = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/messages/conversations`, {
          withCredentials: true,
        });
        if (isMounted) {
          const total = res.data.reduce((sum, c) => sum + (c.unread_count || 0), 0);
          setUnreadCount(total);
        }
      } catch {
        // silently fail
      }
    };

    fetchUnread();
    const interval = setInterval(fetchUnread, 15000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [user]);

  if (!user) return null;

  return (
    <Link
      to="/messages"
      style={{
        position: 'fixed',
        bottom: 90,
        right: 16,
        zIndex: 40,
        width: 40,
        height: 40,
        borderRadius: '50%',
        background: '#1D9E75',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 10px rgba(29,158,117,0.35)',
        textDecoration: 'none',
      }}
      aria-label="Messages"
    >
      <MessageCircle size={20} color="#ffffff" strokeWidth={2} />
      {unreadCount > 0 && (
        <span
          style={{
            position: 'absolute',
            top: -4,
            right: -4,
            width: 16,
            height: 16,
            borderRadius: '50%',
            background: '#ef4444',
            color: '#ffffff',
            fontSize: 9,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1.5px solid #ffffff',
          }}
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </Link>
  );
}
